// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__kq-Ki","col":"Table_col__1Fr_3","fulfillmentStatus":"Table_fulfillmentStatus__31ai1","emailCol":"Table_emailCol__2XRJR"};